import {Table, Row} from "antd";
import {DisplayCostWidget} from "./DisplayCostWidget";
import {DisplayProfitWidget} from "./DisplayProfitWidget";
import {PriceEntryWidget} from "./PriceEntryWidget";
import {MoneyEntryWidget} from "./MoneyEntryWidget";
import {CategoryType} from "../../api/Constants";
import {fixedToDisplayUnit, gramsToLbs} from "../../util/unitutils";
import {DisplayBulkCostWidget} from "./DisplayBulkCostWidget";
import {BookStatusTag} from "../inventory/BookStatusTag";

export const SalesInvoiceTable = ({invoiceItems, updateItems, props}) => {

    const onPriceChange = (item) => (val) => {
        const nextInvoiceItems = {
            ...invoiceItems
        }
        nextInvoiceItems[item.id]['item'].linePrice = val;
        updateItems(nextInvoiceItems);
    }

    const onDiscountChange = (item) => (val) => {
        const nextInvoiceItems = {
            ...invoiceItems
        }
        nextInvoiceItems[item.id].item.lineDiscount = val;
        updateItems(nextInvoiceItems);
    }

    const columns = [
        {
            title: "Name",
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku'
        },
        {
            title: 'Book',
            dataIndex: 'book',
            key: 'book',
            render: (val, record, index) => {
                return <BookStatusTag book={val} />
            }
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                if (record.category === CategoryType.Wholesale) {
                    return <div>
                        <Row>{`${displayQuantity} g`}</Row>
                        <Row>{`${gramsToLbs(displayQuantity)} lbs`}</Row>
                    </div>
                } else {
                    return displayQuantity;
                }
            }
        },
        // {
        //     title: 'Price',
        //     dataIndex: 'invoicePrice',
        //     key: 'invoicePrice',
        //     render: (val, record, index) => {
        //         return <PriceEntryWidget item={record} onPriceChange={onPriceChange(record)} />
        //     }
        // },
        {
            title: 'Line Price',
            dataIndex: 'linePrice',
            key: 'linePrice',
            render: (val, record, index) => {
                return <PriceEntryWidget item={record} onPriceChange={onPriceChange(record)} />
            }
        },
        {
            title: 'Discount',
            dataIndex: 'discount',
            key: 'discount',
            render: (val, record, index) => {
                return <MoneyEntryWidget title={`Discount for ${record.quantity} ${record.name}`} item={record} value={val} onPriceChange={onDiscountChange(record)} />
            }
        },
        {
            title: 'Total Charged',
            dataIndex: 'invoicePrice',
            key: 'totalcharged',
            render: (val, record) => {
                if ((record.linePrice === null) || (record.linePrice === undefined)) {
                    return `$ 0.00`
                }
                return `$ ${record.linePrice - record.lineDiscount}`
            }
        },
        {
            title: 'Cost',
            dataIndex: 'cost',
            key: 'cost',
            render: (val, record, index) => {
                if (record.category === CategoryType.Wholesale) {
                    return <DisplayBulkCostWidget item={record} />
                } else {
                    return <DisplayCostWidget item={record}/>
                }
            }
        },
        {
            title: 'Profit',
            dataIndex: 'cost',
            key: 'profit',
            render: (val, record, index) => {
                return <DisplayProfitWidget item={record} />
            }
        }
    ];

    if (invoiceItems === undefined || invoiceItems === null || (Object.keys(invoiceItems).length === 0)) {
        return <div />
    }

    const invoiceArray = Object.values(invoiceItems).map(val => {
        const lineItem = {
            ...val.item,
            quantity: val.quantity,
        }
        // set discount to default 0
        if (lineItem.discount === undefined) { lineItem.discount = 0 }
        if (lineItem.lineDiscount === undefined) {lineItem.lineDiscount = 0}
        return lineItem;
    });

    return <Table dataSource={invoiceArray} columns={columns} pagination={false} />
}